export {SearchAutocomplete, type SpectrumSearchAutocompleteProps} from '../../../src/autocomplete/SearchAutocomplete';
